import { Megaphone, Lightning, MagicWand, CheckCircle, XCircle, CalendarPlus, ArrowsClockwise, Circle } from "@phosphor-icons/react";

// Maps event type → visual category + icon. Presentation only.
export const EVENT_META = {
  "promotion.created": { cat: "created", Icon: Megaphone },
  "promotion.run.completed": { cat: "run", Icon: Lightning },
  "promotion.content.rendered": { cat: "ai", Icon: MagicWand },
  "campaign.post.published": { cat: "published", Icon: CheckCircle },
  "social.post.published": { cat: "published", Icon: CheckCircle },
  "social.post.failed": { cat: "failed", Icon: XCircle },
  "social.post.created": { cat: "scheduled", Icon: CalendarPlus },
  "social.post.recurrence": { cat: "recurrence", Icon: ArrowsClockwise },
};

export const metaFor = (type) => EVENT_META[type] || { cat: "other", Icon: Circle };

export const CAT_DOT = {
  created: "bg-brand", run: "bg-success", ai: "bg-ai", published: "bg-success",
  failed: "bg-destructive", scheduled: "bg-brand", recurrence: "bg-muted-foreground", other: "bg-muted-foreground",
};
export const CAT_TEXT = {
  created: "text-brand", run: "text-success", ai: "text-ai", published: "text-success",
  failed: "text-destructive", scheduled: "text-brand", recurrence: "text-muted-foreground", other: "text-muted-foreground",
};
export const CAT_BADGE = {
  created: "info", run: "published", ai: "info", published: "published",
  failed: "failed", scheduled: "scheduled", recurrence: "draft", other: "draft",
};
